"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var classnames_1 = require("classnames");

var styles = require("./index.module.css");

function icon(viewBox, children, defaultClassName) {
  var _a = /^.+?\s.+?\s(.+?)\s(.+?)$/.exec(viewBox),
      w = _a[1],
      h = _a[2];

  return React.memo(function (props) {
    var className = props.className,
        style = props.style,
        onClick = props.onClick,
        title = props.title;
    var child = typeof children === 'function' ? children(props) : children;
    return React.createElement("svg", {
      viewBox: viewBox,
      className: classnames_1.default(styles.icon, defaultClassName, className),
      // ie11에서는 다른 브라우저랑 다르게 width가 100%으로 처리되므로 width를 직접 주어서 우회.
      style: __assign({
        width: +w / +h + "em"
      }, style),
      onClick: onClick,
      "aria-labelledby": title && 'title'
    }, title && React.createElement("title", null, title), child);
  });
}

exports.default = icon;